<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><span class="smallcaps">THIS BOOK IS DEDICATED TO GENERAL ARIK SHARON</span>,</span></p>
<p class="ded1"><span><span class="smallcaps">THE DIVISION COMMANDER</span>. <span class="smallcaps">TO KUTI MOTKE YAAKOV AND URI</span>,</span></p>
<p class="ded1"><span><span class="smallcaps">ITS SENIOR OFFICERS</span>. <span class="smallcaps">TO THE OFFICERS AND SOLDIERS</span></span></p>
<p class="ded1"><span><span class="smallcaps">OF THE DIVISION</span>—<span class="smallcaps">THOSE ALIVE</span></span></p>
<p class="ded1"><span><span class="smallcaps">AND THOSE WHO DIED ENABLING ITS VICTORY</span></span></p>
<p class="ded"><span><i>The division suffered 240 casualties. Of those 58 dead</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e689a17e